const DB = "c369-offline";

const openDb = () => new Promise((res, rej) => {
  const r = indexedDB.open(DB, 2);
  r.onupgradeneeded = () => ["queue", "cache"].forEach((s) => !r.result.objectStoreNames.contains(s) && r.result.createObjectStore(s, { keyPath: "id" }));
  r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error);
});

export const tx = async (store, mode, fn) => {
  const db = await openDb();
  return new Promise((res, rej) => {
    const t = db.transaction(store, mode); const req = fn(t.objectStore(store));
    t.oncomplete = () => res(req?.result); t.onerror = () => rej(t.error);
  });
};

// Last-seen copies of the screens that work with no signal.
const CACHED = ["/me", "/workers", "/attendance", "/sites", "/vendors", "/kyc/photo-gaps"];
export const cacheable = (path) => CACHED.some((p) => path === p || path.startsWith(`${p}?`) || path.startsWith(`${p}/`));
export const cacheGet = async (path) => { try { return (await tx("cache", "readonly", (s) => s.get(path)))?.data; } catch { return undefined; } };
export const cachePut = (path, data) => tx("cache", "readwrite", (s) => s.put({ id: path, data, at: new Date().toISOString() })).catch(() => {});
export const cacheClear = () => { localStorage.removeItem("c369-me"); return tx("cache", "readwrite", (s) => s.clear()).catch(() => {}); };

// "No auth" = the app was opened with no signal and sign-in could not load yet; treated like offline.
let noAuth = false;
export const setNoAuth = (v) => { noAuth = v; };
export const offlineNow = () => !navigator.onLine || noAuth;
export const isNetErr = (e) => !!e && !e.response && (e.code === "ERR_NETWORK" || e.message === "Network Error");
export const NEEDS_SIGNAL = "This needs signal. Open it once with signal so it's saved on this phone.";
